var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 291,
    viewBox: "0 0 291 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.5 266.75C212.465 266.75 266.75 212.465 266.75 145.5C266.75 78.5355 212.465 24.25 145.5 24.25C78.5355 24.25 24.25 78.5355 24.25 145.5C24.25 212.465 78.5355 266.75 145.5 266.75Z",
    stroke: "white",
    strokeWidth: 18.1875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.5 194C172.286 194 194 172.286 194 145.5C194 118.714 172.286 97.0001 145.5 97.0001C118.714 97.0001 97 118.714 97 145.5C97 172.286 118.714 194 145.5 194Z",
    fill: "#F60000",
    stroke: "#F60000",
    strokeWidth: 18.1875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.ab7dae84a28530baebcfafbea58c8bca.svg";
export { ForwardRef as ReactComponent };